import { render, staticRenderFns } from "./registries-selector.vue?vue&type=template&id=59b94caa&scoped=true&"
import script from "./registries-selector.vue?vue&type=script&lang=js&"
export * from "./registries-selector.vue?vue&type=script&lang=js&"
import style0 from "./registries-selector.vue?vue&type=style&index=0&id=59b94caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b94caa",
  null
  
)

export default component.exports